import { Col, Row, Switch, Typography } from 'antd';
import { NotifyUseCaseInterface } from 'application/usecases/NotifyUseCase';
import { UserUseCaseInterface } from 'application/usecases/UserUseCase';
import { SettingNotifyData } from 'domain/entities/NotifyEntity';
import { openErrorNoti } from 'presentation/components/Notification';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ItemData } from '../models/ItemData';

interface props {
    notifyUseCase: NotifyUseCaseInterface;
    userUseCase: UserUseCaseInterface;
}

export const ItemComponent = ({ userUseCase, notifyUseCase }: props) => {
    const dispatch = useDispatch();
    const [memberAccountId, setMemberAccountId] = useState<any>();
    const [notifyStatus, setNotifystatus] = useState<boolean[]>([false, false, false]);
    const [notifyStatusString, setNotifystatusString] = useState<string[]>(['', '', '']);

    useEffect(() => {
        (async () => {
            await getUserInfo();
        })();
    }, []);

    const getUserInfo = async () => {
        try {
            dispatch(startFetching());
            const response = await userUseCase.getUserInfo();
            if (response && response.result) {
                const statuseResponse: boolean[] = [
                    response.result.settingNotifySystem == '1' ? true : false,
                    response.result.settingNotifyTransaction == '1' ? true : false,
                    response.result.settingNotifyMember == '1' ? true : false,
                ];
                setNotifystatus(statuseResponse);
                const statuseStringResponse: string[] = [
                    response.result.settingNotifySystem ? response.result.settingNotifySystem : '0',
                    response.result.settingNotifyTransaction
                        ? response.result.settingNotifyTransaction
                        : '0',
                    response.result.settingNotifyMember ? response.result.settingNotifyMember : '0',
                ];
                setNotifystatusString(statuseStringResponse);
                setMemberAccountId(response.result.memberAccountId);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const changeNotify = async (stt: boolean, index: number) => {
        try {
            dispatch(startFetching());

            const statuseRequest: boolean[] = [...notifyStatus];
            statuseRequest[index] = stt;
            setNotifystatus(statuseRequest);

            const statusRequestString: any[] = [...notifyStatusString];
            statusRequestString[index] = Number(stt) + '';
            setNotifystatusString(statusRequestString);

            const dataRequest: SettingNotifyData = {
                memberId: memberAccountId,
                notifyStatus: statusRequestString,
            };

            await notifyUseCase.settingNotifyForUser(dataRequest);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const itemData: ItemData[] = [
        {
            title: '会員ステータス自動通知',
            isNotify: notifyStatus[0],
        },
        {
            title: '取引自動通知',
            isNotify: notifyStatus[1],
        },
        {
            title: '運営お知らせ通知',
            isNotify: notifyStatus[2],
        },
    ];
    return (
        <Row className="item-container" wrap>
            {itemData.map((element: ItemData, index: number) => (
                <Row className="tabs-element button-style glowd-on-hover" key={index}>
                    <Row gutter={[40, 0]} className="content h-full">
                        <Col className="title max-w-[85%]">
                            <Typography.Text style={{ fontSize: 20 }}>
                                {element.title}
                            </Typography.Text>
                        </Col>
                        <Col>
                            <Switch
                                checked={element.isNotify}
                                onChange={(stt) => {
                                    changeNotify(stt, index);
                                }}
                            />
                        </Col>
                    </Row>
                </Row>
            ))}
        </Row>
    );
};
